<template>
  <v-row justify="center">
    <v-dialog v-model="activarModal" persistent width="600px">     
      <v-card style="text-align: justify; color:black;">
        <v-card-title class="text-h6 primary" style="color:white; text-align: center;">          
           <center><p class="text-center">AVISO DE PRIVACIDAD</p></center>
        </v-card-title>
        <br>        
        <v-card-text class="text-justify" :class="ventana">
          En cumplimiento con lo establecido por la Ley Federal de Protección de Datos Personales
          en Posesión de los Particulares (LFPDPPP) y con el fin de darle a conocer la información
          relativa a las características principales del tratamiento al que serán sometidos sus Datos
          Personales, se emite el presente Aviso de Privacidad.          
        </v-card-text>
        <v-card-text class="text-justify" :class="ventana">
          <b>Power Street de México, S.A. de C.V.</b> es una empresa ubicada en Francisco Ayala 85 Col.
          Vista Alegre, Alcaldía. Cuauhtémoc, C.P. 06860, México, Ciudad de México, es el 
          responsable del uso, manejo, almacenamiento y confidencialidad de acuerdo con lo
          establecido en la (LFPDPPP)
        </v-card-text>
        <v-card-text class="text-justify" :class="ventana">
            Los datos personales que recabamos de usted serán utilizados para las siguientes
            finalidades primarias:
            <br>
            <br>
            <ul>
                <li>Establecer la relación laboral.</li>
                <li>Realizar la gestión de su puesto y prestaciones laborales</li>
                <li>El cumplimiento de las disposiciones del contrato laboral.</li>
                <li>La realización de un expediente laboral.</li>
                <li>Para darle de alta en el Instituto Mexicano del Seguro Social.</li>
                <li>Para elaborar credenciales de acceso al centro de trabajo.</li>
                <li>Contactar a familiares, señalados por usted en caso de emergencia.</li>
                <li>Proceso de capacitación y desarrollo personal</li>
                <li>Coordinación de actividades organizados por <b>Power Street de México SA de CV.</b></li>
                <li>Contactarlo para cualquier tema relacionado con la Relación Laboral o el presente<br>
                Aviso de Privacidad</li>
                <li>En resumen, para realizar todas las actividades necesarias para la administración y<br>
                gestión de su puesto de trabajo y demás prestaciones laborales.</li>
            </ul>
            <br>
            Podremos tratar sus Datos Personales con las finalidades secundarias que se enlistan a
            continuación:
            <br>
            <ul>
                <li>Aquellas relacionadas con la mejora y fomento de un mejor entorno organizacional<br>
                (difusión de felicitaciones, celebraciones especiales)</li>
            </ul>
            <br>
            Datos Recabados:
            <br>
            <ul>
                <li>Datos de identificación; INE, CURP, RFC, Forma Migratoria (FM), lugar y fecha de<br>
                nacimiento, nacionalidad, edad. </li>
                <li>Datos de contacto; domicilio particular, número de teléfono fijo y/o celular, correo<br>
                electrónico.</li>
                <li>Datos académicos </li>
                <li>Datos laborales</li>
                <li>Datos de referencia; en el que usted previamente obtuvo el consentimiento de<br>
                dichas personas y le ha informado de nuestro aviso de privacidad.</li>                
            </ul>
            <br>
            Datos personales sensibles:
            <br>
            <br>
            Para cumplir con las finalidades de nuestra relación mencionada en el presente aviso de<br>
            privacidad, es posible tratemos de usted los siguientes datos sensibles:
            <ul>
                <li>Datos de salud</li>
                <li>Datos biométricos </li>
                <br>
                Nos comprometemos a que los mismos serán tratados bajo estrictas medidas de
                seguridad, garantizando su confidencialidad
            </ul>
        </v-card-text>
        <v-card-text class="text-justify" :class="ventana">
            Te informamos que los datos personales podrán ser compartidos de <b>Power Street de
            México S.A. de C.V.</b> a empresas del mismo grupo, y a autoridades gubernamentales que
            nos soliciten mediante la ley que permita informar los datos personales, sin tu
            conocimiento.<br>
            <br>
            Al momento de concretar la relación laboral, reconoce que se dio a conocer el presente
            Aviso de privacidad, que está de acuerdo con los términos establecidos en el presente y
            otorga su consentimiento para el tratamiento de sus datos personales.
            <br>
            <br>
            Es importante informarle que usted tiene derecho al <b>Acceso, Rectificación, Cancelación y
            Oposición “Derechos de ARCO”,</b> con apego al capítulo IV en su artículo 29 de la Ley
            Federal de Protección de Datos Personales en Posesión de los Particulares (LFPDPPP), así
            como la revocación de su consentimiento.<br>
            <br>
            <ul>
                <li><b>Acceso:</b> es su derecho conocer los datos personales que están en nuestra base de
                datos y la finalidad de ser tratados y/o utilizados</li>
                <li><b>Rectificación:</b> podrá solicitar la corrección de los datos   personales que
                proporcionaste.</li>
                <li><b>Cancelación:</b> es su derecho solicitar la cancelación o eliminación de sus
                datos personales en nuestra base de datos, cuando piense que no están usándose
                adecuadamente y solo procederá cuando ya no exista un contrato de por medio
                con el cliente y <b>Power Street de México, S.A de C.V.</b></li>
                <li><b>Oposición:</b> tiene derecho a oponerse al uso de los datos personales.</li>
                <br>
                En caso de ejercer su derecho de ARCO deberá hacerlo mediante correo electrónico a
                <a>buzon@powerstreet.com.mx</a> y/o por escrito en nuestro domicilio, dirigido a <b>Power
                Street de México S.A de C.V.</b> En ambos casos deberá proporcionar todos sus datos
                personales descritos en el presente aviso, incluyendo copia simple de identificación
                oficial, o copia simple y original para su cotejo con la finalidad de acreditar la
                representación legal del titular.                
            </ul><br>            
            <br>
            Cualquier queja o información adicional respecto al tratamiento de sus datos personales o
            duda en relación con la Ley Federal de Protección de Datos Personales en Posesión de los
            Particulares o con su Reglamento podrá dirigirla al INAI. Para más información visite
            <a href="https://home.inai.org.mx/">www.inai.org.mx</a>
            <br><br>
            Las actualizaciones al presente Aviso de Privacidad serán notificadas a través de la página
            de internet <a href="https://www.power-street.com/">www.power-street.com</a>
            <br>
            <br>
            Fecha de última modificación de este Aviso de Privacidad 10 Octubre de 2019

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>         
          <v-btn color="primary darken-1" text  @click="cerrar_modal()">Cerrar</v-btn>       
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
export default {
  props: {
    activarModal: Boolean,
    ventana:String    
  },
  data: () => ({    
  }),
  methods: {
    cerrar_modal() {
      this.$emit("modal_cancelar", false);
    }
  },
};
</script>
<style scoped>
.theme--light.v-card > .v-card__text, .theme--light.v-card .v-card__subtitle {
    color: #000000d6;
}
.letra{
  font-size: 15px;
}
</style>